.heading {
  margin-top: var(--dds-spacing-small-16);
}

.wrapper {
  fieldset {
    border: none;
    margin-bottom: var(--dds-spacing-small-16);
    margin-top: var(--dds-spacing-large-48);
    padding: 0;
  }
}

.virksomhetOppsummering {
  margin-top: var(--dds-spacing-medium-32);
}
